import React from 'react';
import '../index.css';

const Contact = () => {
  return (
    <div className="container" style={{ maxWidth: '900px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{ 
        textAlign: 'center', 
        marginBottom: '50px',
        animation: 'fadeInUp 0.6s ease-out'
      }}>
        <h1 style={{
          color: 'var(--text-accent)',
          fontSize: '42px',
          fontWeight: '800',
          marginBottom: '16px',
          textTransform: 'uppercase',
          letterSpacing: '2px'
        }}>
          Get in Touch
        </h1>
        <p style={{
          color: 'var(--text-secondary)',
          fontSize: '18px',
          lineHeight: '1.6'
        }}>
          Have questions, feedback, or just want to say hi?
        </p>
      </div>

      <div style={{
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        padding: '40px',
        border: '1px solid var(--border)',
        lineHeight: '1.8',
        fontSize: '16px',
        animation: 'fadeInUp 0.8s ease-out',
        marginBottom: '30px'
      }}>
        
        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Reach Out on Twitter
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '20px' }}>
            The best way to reach me is on Twitter. Whether you have feedback, questions, partnership inquiries, 
            or just want to chat about gaming and indie development, I'm all ears.
          </p>
          <div style={{ textAlign: 'center', marginTop: '24px' }}>
            <a 
              href="https://twitter.com/AlonelyCat31" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '12px',
                padding: '16px 32px',
                backgroundColor: '#1DA1F2',
                color: 'white',
                borderRadius: '12px',
                textDecoration: 'none',
                fontWeight: '600',
                fontSize: '18px',
                transition: 'all 0.3s ease',
                boxShadow: '0 4px 12px rgba(29, 161, 242, 0.3)'
              }}
              onMouseEnter={(e) => {
                e.target.style.backgroundColor = '#1a91da';
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = '0 6px 16px rgba(29, 161, 242, 0.4)';
              }}
              onMouseLeave={(e) => {
                e.target.style.backgroundColor = '#1DA1F2';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 4px 12px rgba(29, 161, 242, 0.3)';
              }}
            >
              <svg 
                width="24" 
                height="24" 
                viewBox="0 0 24 24" 
                fill="white"
                style={{ flexShrink: 0 }}
              >
                <path d="M23.643 4.937c-.835.37-1.732.62-2.675.733.962-.576 1.7-1.49 2.048-2.578-.9.534-1.897.922-2.958 1.13-.85-.904-2.06-1.47-3.4-1.47-2.572 0-4.658 2.086-4.658 4.66 0 .364.042.718.12 1.06-3.873-.195-7.304-2.05-9.602-4.868-.4.69-.63 1.49-.63 2.342 0 1.616.823 3.043 2.072 3.878-.764-.025-1.482-.234-2.11-.583v.06c0 2.257 1.605 4.14 3.737 4.568-.392.106-.803.162-1.227.162-.3 0-.593-.028-.877-.082.593 1.85 2.313 3.198 4.352 3.234-1.595 1.25-3.604 1.995-5.786 1.995-.376 0-.747-.022-1.112-.065 2.062 1.323 4.51 2.093 7.14 2.093 8.57 0 13.255-7.098 13.255-13.254 0-.2-.005-.402-.014-.602.91-.658 1.7-1.477 2.323-2.41z"/>
              </svg>
              @AlonelyCat31
            </a>
          </div>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            What to Expect
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            I read all messages personally, but as a solo developer running GamersUnion, response times can vary. 
            I'll do my best to get back to you within a few days. If it's urgent or relates to a security issue, 
            please mention that clearly.
          </p>
        </section>

        <section style={{ marginBottom: '40px' }}>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Common Questions
          </h2>
          
          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              For Indie Developers
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              Want to showcase your game or host a giveaway? Interested in partnership opportunities? Send me a DM 
              on Twitter with details about your game, and we'll figure out how to get you featured on GamersUnion.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Technical Issues
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              If you're experiencing bugs, errors, or technical problems with the site, reach out on Twitter with 
              a description of the issue, what you were doing when it happened, and your browser/device info if possible. 
              Screenshots are always helpful.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Feature Requests
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              Have an idea for a feature that would make GamersUnion better? I love hearing from the community. 
              Drop me a message on Twitter explaining what you'd like to see and why it would be useful. I can't 
              implement everything, but I seriously consider all suggestions.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Moderation Issues
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              If you need to report a user, contest a moderation decision, or flag inappropriate content, reach out 
              on Twitter. Include relevant details like usernames, post links, or screenshots if applicable.
            </p>
          </div>

          <div style={{ marginBottom: '24px' }}>
            <h3 style={{ 
              color: 'var(--primary)', 
              fontSize: '20px', 
              fontWeight: '600',
              marginBottom: '12px'
            }}>
              Press & Media
            </h3>
            <p style={{ color: 'var(--text)', marginBottom: '12px' }}>
              If you're writing about GamersUnion or want to interview me for an article or podcast, send a DM on 
              Twitter with your publication/channel info and what you'd like to discuss. I'm happy to chat about 
              indie gaming, community building, and the platform.
            </p>
          </div>
        </section>

        <section>
          <h2 style={{ 
            color: 'var(--text-accent)', 
            fontSize: '28px', 
            fontWeight: '700',
            marginBottom: '20px',
            borderBottom: '3px solid var(--primary)',
            paddingBottom: '10px'
          }}>
            Other Ways to Connect
          </h2>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            While Twitter is the primary contact method, you can also interact with me through GamersUnion itself. 
            I'm active in the community, responding to posts and engaging with users. If you want to give general 
            feedback or share your experience, consider posting in the community section or leaving a review.
          </p>
          <p style={{ color: 'var(--text)', marginBottom: '16px' }}>
            You can also support the platform's development by donating at{' '}
            <a 
              href="https://razorpay.me/@alonelycat" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: 'var(--primary)', textDecoration: 'underline' }}
            >
              razorpay.me/@alonelycat
            </a>. Every contribution helps keep GamersUnion running and allows me to dedicate more time to building 
            features the community wants.
          </p>
        </section>

      </div>

      <div style={{
        textAlign: 'center',
        padding: '30px',
        backgroundColor: 'var(--card-bg)',
        borderRadius: '16px',
        border: '1px solid var(--border)'
      }}>
        <h3 style={{ color: 'var(--text-accent)', fontSize: '24px', marginBottom: '16px' }}>
          Looking Forward to Hearing From You
        </h3>
        <p style={{ color: 'var(--text)', fontSize: '16px' }}>
          Whether you have feedback, questions, or just want to say hi, I genuinely appreciate every message. 
          GamersUnion is built for the community, and your input helps shape its future.
        </p>
      </div>
    </div>
  );
};

export default Contact;
